import { assign } from 'lodash'

export default class StudyRequest {
    constructor(data) {
        assign(this, data)
    }
}
